import { Button, CircularProgress, IconButton, Radio } from "@material-ui/core";
import { Delete, Edit, FilterList } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import { db, storage } from "../../../firebase";
import Modal from "../../Atoms/modal/CustomModal";
import EventForm from "./EventForm";
import ReactToPrint from "react-to-print";
import "./Events.css";

const getDate = (t) => {
  // const t = new Date(1970, 0, 1);
  // t.setSeconds(sec);
  return t.toLocaleDateString();
};

function Events() {
  const [events, setEvents] = useState([]);
  const [visible, setVisible] = useState(false);
  const [fetchAgain, setFetchAgain] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [deleteEventChoice, setDeleteEventChoice] = useState(false);
  const [eventKey, setEventKey] = useState(0);
  const [choiceState, setChoiceState] = useState([]);
  const [sortBy, setSortBy] = useState(1);
  const [select, setSelect] = useState("organizedOn");
  const [showTools, setShowTools] = useState(false);

  const printTableRef = useRef();

  useEffect(() => {
    const deleteFn = async () => {
      setLoading(true);
      try {
        const key = eventKey;

        await db.collection("Events").doc(key).delete();
        setEvents((prev) => prev.filter((item) => item.key !== key));

        // const storageRef = storage.ref();
        const listImages = await storage
          .ref(`Events/${key}/EventMedia`)
          .listAll();

        const posterImages = await storage
          .ref(`Events/${key}/EventPosters`)
          .listAll();

        for (let i = 0; i < listImages.items.length; i++) {
          await listImages.items[i].delete();
        }

        for (let i = 0; i < posterImages.items.length; i++) {
          await posterImages.items[i].delete();
        }

        // console.log("deleted");
        setFetchAgain((prev) => !prev);
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
      setEventKey(0);
    };

    if (deleteEventChoice) {
      deleteFn();
    }
  }, [deleteEventChoice, eventKey]);

  const deleteEvent = async (key, name) => {
    setMessage(`Do you want to DELETE the Event: "${name}"?`);
    setShowModal(true);
    setChoiceState([deleteEventChoice, setDeleteEventChoice]);
    setEventKey(key);
  };

  const editBtn = (key, name) => {
    setMessage(`Do you want to EDIT the Event: "${name}"?`);
    setShowModal(true);
    setChoiceState([visible, setVisible]);

    const event = events.filter((item) => item.key === key);
    // console.log(event);
    setData(event[0]);
  };

  useEffect(() => {
    setLoading(true);
    setEvents([]);
    const fetchData = async () => {
      try {
        const eventsSnapShot = await db
          .collection("Events")
          .orderBy(select, sortBy === 0 ? "desc" : undefined)
          .get();
        eventsSnapShot.forEach((item) =>
          setEvents((prev) => [...prev, item.data()])
        );
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    };
    fetchData();
  }, [fetchAgain, sortBy, select]);

  return (
    <div className="events">
      {/* <h1>Events</h1> */}

      {loading ? (
        <div className="loading__center">
          <CircularProgress style={{ height: 100, width: 100 }} />
        </div>
      ) : (
        <>
          <div className="events__list" ref={printTableRef}>
            <div className="events__toolbox__icon">
              <IconButton
                style={{
                  backgroundColor: "white",
                  boxShadow: "1px 3px 10px -1px black",
                }}
                onClick={() => setShowTools((p) => !p)}
              >
                <FilterList fontSize="default" style={{ color: "black" }} />
              </IconButton>
              {showTools && (
                <div className="events__toolbox">
                  <select
                    value={select}
                    onChange={(e) => setSelect(e.target.value)}
                  >
                    <option default value="organizedOn">
                      Date
                    </option>
                    <option value="eventName">Event Name</option>
                    <option value="organizedBy">Organizer</option>
                  </select>

                  <div>
                    <label>
                      asc:
                      <Radio
                        checked={sortBy === 1}
                        onChange={() => setSortBy(1)}
                      />
                    </label>
                    <label>
                      desc:
                      <Radio
                        checked={sortBy === 0}
                        onChange={() => setSortBy(0)}
                      />
                    </label>
                  </div>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setData(null);
                      setVisible(true);
                    }}
                  >
                    New Event
                  </Button>

                  <ReactToPrint
                    copyStyles
                    trigger={() => (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{
                          padding: "0",
                          display: "block",
                          // marginTop: "5px",
                          margin: "5px auto auto auto ",
                        }}
                      >
                        Print
                      </Button>
                    )}
                    content={() => printTableRef.current}
                  />
                </div>
              )}
            </div>

            <table>
              <tbody>
                <tr>
                  <th>Event Name</th>
                  <th>Date</th>
                  <th>Organizer</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>

                {events.map((item) => (
                  <tr key={item.key}>
                    <td>{item.eventName}</td>
                    <td>{getDate(item.organizedOn.toDate())}</td>
                    <td>{item.organizedBy}</td>
                    <td>
                      <IconButton
                        onClick={() => editBtn(item.key, item.eventName)}
                      >
                        <Edit />
                      </IconButton>
                    </td>
                    <td>
                      <IconButton
                        onClick={() => deleteEvent(item.key, item.eventName)}
                      >
                        <Delete />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {visible && (
        <EventForm
          state={[visible, setVisible]}
          setFetchAgain={setFetchAgain}
          data={data}
        />
      )}
      {showModal && (
        <Modal
          message={message}
          choiceState={[...choiceState]}
          modalState={[showModal, setShowModal]}
        />
      )}
    </div>
  );
}

export default Events;
